export default __webpack_public_path__ + "static/media/CICLISTA PRO.4b90c7e8.svg";